import { action, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React, {ChangeEventHandler} from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {PromiseMessage} from '../../../../../../lib/components';
import {logger} from '../../../../../../lib/helpers';
import {MQOptions} from '../../models';
import {MQDataPairStore} from '../stores/MQDataPairStore';

@observer
export class MQDataPairLeft extends React.Component<{
  options: MQOptions,
  store: MQDataPairStore
}> {
  @action
  handleFileChange: ChangeEventHandler<HTMLInputElement> =
    (event) => {
      const files = event.target.files;
      logger.log('MQDataPairLeft.handleFileChange', files);
      if (files === null || files.length === 0)
        this.props.store.setSelectedFile(null);
      else
        this.props.store.setSelectedFile(files[0]);
    };

  upload = () => {
    this.props.store.upload();
  };

  constructor(
    props: {
      options: MQOptions,
      store: MQDataPairStore
    }
  ) {
    super(props);
    makeObservable(this);
  }

  render() {
    const leftSide = this.props.options.leftSide;
    const store = this.props.store;
    const {left, selectedFile, uploadState} = store;
    const value = left.value;

    if (leftSide === 'text')
      return (
        <TextareaAutosize className="form-control"
                          value={left.value}
                          onChange={left.onChangeHandler}/>
      );

    // leftSide === 'image'
    if (value === '') {
      // file has not been uploaded
      const uploading = uploadState?.isPending === true;

      return (
        <>
          <div className="row no-gutters">
            <div className="col">
              <input type="file" className="form-control-file"
                     onChange={this.handleFileChange}/>
            </div>
            <div className="col-auto">
              <button type="button" className="btn btn-primary"
                      disabled={selectedFile === null || uploading}
                      onClick={this.upload}>
                Upload
              </button>
            </div>
          </div>
          <PromiseMessage label="Uploading" state={uploadState} align="right"/>
        </>
      );
    }

    return (<>
      <div className="row no-gutters">
        <div className="col">
          <img src={value} className="img-fluid" alt="Image not found"/>
        </div>
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={left.clear}>
            clear
          </button>
        </div>
      </div>
    </>);
  }
}
